'use client';

import { type FC } from 'react';
import styles from './CardAside.module.css';
import type { CardAsideProps } from './CardAside.types';
import { getClasses } from '@/_utils/classnames';

export const CardAside: FC<CardAsideProps> = ({
  children,

  isNavigationControl,
}) => {
  const cardAsideClasses: string = getClasses(styles.cardAside, {
    [styles.cardAsideNavigationControl]: isNavigationControl,
  });

  return <aside className={cardAsideClasses}>{children}</aside>;
};
